import useCommonInbox from "../../../../../../../packages/libraries/src/hooks/obps/useCommonInbox";
import useNOCInbox from "../../../../../../../packages/libraries/src/hooks/obps/useNOCInbox";
import useTPInbox from "../../../../../../../packages/libraries/src/hooks/obps/useTPInbox";
import { useState, useEffect } from "react";

// Assuming isMobile is determined based on the device
const isMobile = window.innerWidth <= 768; // Example, adjust as needed.

export const fetchApplications = (tenantId, userBusinessServices, officerRole) => {
  // Removed unnecessary `initialStates` and set explicit initial states
  const [sortParams, setSortParams] = useState([{ id: "applicationDate", desc: false }]);
  const [pageSize, setPageSize] = useState(3000);
  const [pageOffset, setPageOffset] = useState(0);
  const [searchParams, setSearchParams] = useState({});
  const hasAuthorizedRoles = officerRole?.some((role) => role.code === "NODAL_OFFICER_AWAS" || role.code === "Nodal Officer");
  const paginationParams = isMobile
    ? { limit: 100, offset: 0, sortBy: sortParams[0]?.id, sortOrder: sortParams[0]?.desc ? "DESC" : "ASC" }
    : { limit: pageSize, offset: pageOffset, sortBy: sortParams[0]?.id, sortOrder: sortParams[0]?.desc ? "DESC" : "ASC" };
  const nocDepartmentRoles = [
    "Acquisition_Section_Incharge",
    "Nazul_Section_Incharge",
    "Improvement_Trust_Incharge",
    "Property_Section_Incharge",
    "Urban_Ceiling_Incharge",
    "Tehsildar",
    "AAI_General_Manager",
    "Army_Airforce_Station_Officer",
    "Fire_Chief_Officer",
    "Irrigation_Executive_Officer",
    "UPMRC_MD",
    "Forest_District_Officer",
    "Railways_Section_Engineer",
    "Power_Executive_Engineer",
    "NHAI_Project_Director",
    "PWD_Executive_Engineer",
    "ASI_Superintendent",
    "Jail_Superintendent",
    "ULB_Nagar_Aayukt",
    "Environment_UPPCB_Secretary",
    "Security_ADG",
    "UPAVP_Chief_Architect",
  ];

  const isNocDepartment = officerRole?.some((role) => nocDepartmentRoles.includes(role.code));

  console.log("isNOCDepartment", isNocDepartment, userBusinessServices);

  const { isFetching, isLoading: hookLoading, searchResponseKey, data, searchFields, ...rest } = hasAuthorizedRoles
    ? useTPInbox({
      tenantId,
      filters: { ...searchParams, ...paginationParams, sortParams },
      config: { staleTime: 0, cacheTime: 0, refetchOnMount: true, refetchOnWindowFocus: false, refetchOnReconnect: true },
    })
    : isNocDepartment
      ? useNOCInbox({
        tenantId,
        userBusinessServices,
        filters: { ...searchParams, ...paginationParams, sortParams },
        config: { staleTime: 0, cacheTime: 0, refetchOnMount: true, refetchOnWindowFocus: false, refetchOnReconnect: true },
      })
      : useCommonInbox({
        tenantId,
        userBusinessServices,
        filters: { ...searchParams, ...paginationParams, sortParams },
        config: { staleTime: 0, cacheTime: 0, refetchOnMount: true, refetchOnWindowFocus: false, refetchOnReconnect: true },
      });

  // Ensure that the data exists before returning it
  return { applications: data || [], isOfficerLTP: hasAuthorizedRoles, isFetching };
};
